/**
 * @generated SignedSource<<5ffabb710d8b713be312cf8231fe47d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "legalContractId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "facilityId",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "legalContractId",
        "variableName": "legalContractId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "LineOfService",
  "kind": "LinkedField",
  "name": "lineOfService",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveFrom",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveTo",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "addressLine1",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "addressLine2",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v12 = [
  (v3/*: any*/),
  (v2/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "LocationVersion",
  "kind": "LinkedField",
  "name": "applicableVersion",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tin",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FacilityInfoMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FacilityMutationGroup",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "FacilityModifyPayload",
            "kind": "LinkedField",
            "name": "modify",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Facility",
                "kind": "LinkedField",
                "name": "facility",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FacilityInfo_Facility"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FacilityInfoMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FacilityMutationGroup",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "FacilityModifyPayload",
            "kind": "LinkedField",
            "name": "modify",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Facility",
                "kind": "LinkedField",
                "name": "facility",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LegalContract",
                    "kind": "LinkedField",
                    "name": "legalContract",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LegalContractLineOfService",
                        "kind": "LinkedField",
                        "name": "linesOfService",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "otherServicesDiscountPercentage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "percentageOfBase",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isComplex",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Location",
                        "kind": "LinkedField",
                        "name": "locations",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityVersion",
                    "kind": "LinkedField",
                    "name": "applicableVersion",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProviderBillingAddress",
                    "kind": "LinkedField",
                    "name": "billingAddresses",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LegalContractLineOfService",
                        "kind": "LinkedField",
                        "name": "lineOfService",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LineOfService",
                            "kind": "LinkedField",
                            "name": "lineOfService",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "npi",
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "billingPermitted",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addressLine3",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "County",
                        "kind": "LinkedField",
                        "name": "county",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneNumber",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityLocation",
                    "kind": "LinkedField",
                    "name": "locations",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Location",
                        "kind": "LinkedField",
                        "name": "location",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BillingGroup",
                            "kind": "LinkedField",
                            "name": "billingGroup",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LegalContractLineOfService",
                        "kind": "LinkedField",
                        "name": "legalContractLineOfService",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityLocationVersion",
                        "kind": "LinkedField",
                        "name": "applicableVersion",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showInDirectory",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7c17c00da1429299cf732be0eb2da3e0",
    "id": null,
    "metadata": {},
    "name": "FacilityInfoMutation",
    "operationKind": "mutation",
    "text": "mutation FacilityInfoMutation(\n  $id: ID!\n  $legalContractId: ID!\n) {\n  facility {\n    modify(input: {facilityId: $id, legalContractId: $legalContractId}) {\n      facility {\n        ...FacilityInfo_Facility\n        id\n      }\n    }\n  }\n}\n\nfragment ContractLinesOfServiceFragments_LinesOfService on LegalContractLineOfService {\n  id\n  lineOfService {\n    id\n    name\n  }\n  otherServicesDiscountPercentage\n  percentageOfBase\n  isComplex\n  effectiveFrom\n  effectiveTo\n}\n\nfragment FacilityInfo_Facility on Facility {\n  id\n  legalContract {\n    id\n    name\n    linesOfService {\n      ...ContractLinesOfServiceFragments_LinesOfService\n      id\n    }\n    locations {\n      ...LocationFragments_LocationDropdown\n      id\n    }\n  }\n  applicableVersion {\n    displayName\n    id\n  }\n  billingAddresses {\n    ...ProviderBillingAddresses_Addresses\n    id\n  }\n  locations {\n    ...FacilityLocations_Locations\n    id\n  }\n}\n\nfragment FacilityLocations_Locations on FacilityLocation {\n  id\n  location {\n    addressLine1\n    addressLine2\n    city\n    state\n    postalCode\n    applicableVersion {\n      name\n      id\n    }\n    billingGroup {\n      id\n      name\n      tin\n    }\n    id\n  }\n  legalContractLineOfService {\n    id\n    lineOfService {\n      id\n      name\n    }\n  }\n  applicableVersion {\n    showInDirectory\n    id\n  }\n}\n\nfragment LocationFragments_LocationDropdown on Location {\n  id\n  addressLine1\n  addressLine2\n  city\n  state\n  postalCode\n  applicableVersion {\n    name\n    id\n  }\n}\n\nfragment ProviderBillingAddresses_Addresses on ProviderBillingAddress {\n  id\n  lineOfService {\n    id\n    lineOfService {\n      name\n      id\n    }\n  }\n  npi\n  tin\n  billingPermitted\n  name\n  addressLine1\n  addressLine2\n  addressLine3\n  city\n  state\n  postalCode\n  county {\n    id\n    name\n    state\n  }\n  phoneNumber\n  effectiveFrom\n  effectiveTo\n}\n"
  }
};
})();

node.hash = "c429d1a89f8bcb81294a106f00970bae";

export default node;
